// src/features/organisation/hooks/useSiteCertifications.ts
import { useState, useEffect } from 'react';
import { SiteCertification, SiteCertificationCreateDto } from '../../../types/organisation';
import { apiClient } from '../../../services/api/client';

export const useSiteCertifications = () => {
  const [certifications, setCertifications] = useState<SiteCertification[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchCertifications = async () => {
    try {
      setLoading(true);
      setError(null);
      // Pour l'instant, on récupère toutes les certifications
      // TODO: Implémenter un endpoint pour récupérer toutes les certifications
      const response = await apiClient.get('/organisation/site-certifications/expired');
      setCertifications(response);
    } catch (err) {
      setError(err as Error);
      console.error('Erreur lors du chargement des certifications:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCertifications();
  }, []);

  return {
    certifications,
    loading,
    error,
    refresh: fetchCertifications
  };
};

export const useSiteCertificationActions = () => {
  const createCertification = async (siteId: number, certificationData: SiteCertificationCreateDto): Promise<SiteCertification> => {
    try {
      const response = await apiClient.post(`/organisation/site-certifications/site/${siteId}`, certificationData);
      return response;
    } catch (error) {
      console.error('Erreur lors de la création de la certification:', error);
      throw error;
    }
  };

  const updateCertification = async (siteId: number, certId: number, certificationData: SiteCertificationCreateDto): Promise<SiteCertification> => {
    try {
      const response = await apiClient.put(`/organisation/site-certifications/site/${siteId}/cert/${certId}`, certificationData);
      return response;
    } catch (error) {
      console.error('Erreur lors de la modification de la certification:', error);
      throw error;
    }
  };

  const deleteCertification = async (siteId: number, certId: number): Promise<void> => {
    try {
      await apiClient.delete(`/organisation/site-certifications/site/${siteId}/cert/${certId}`);
    } catch (error) {
      console.error('Erreur lors de la suppression de la certification:', error);
      throw error;
    }
  };

  return {
    createCertification,
    updateCertification,
    deleteCertification
  };
};